<template>
  <div>
    <Page>
      <div class="error-message" data-test-id="error-message">
        <div class="error-message__video-wrapper">
          <LazyVideoPlayer :src="`https://vz-df3f7e0c-f41.b-cdn.net/${randomVideoId}/playlist.m3u8`" />
        </div>
        <h2 class="h-margin-top">
          {{ title }}
        </h2>
        <p>{{ subTitle }}</p>
        <Btn
          class="h-margin-top"
          @click="hasHistory && $router.options.history.state.back != null ? $router.go(-1) : $router.push({name:`${$lang}-index`})">
          {{ $t('general/go-shopping') }}
        </Btn>
      </div>
    </Page>
  </div>
</template>
<script setup>
const { $lang } = useNuxtApp()
const props = defineProps({
  error: Object
})
useHead({
  title: 'Oops'
})

const hasHistory = computed(() => process.client && window.history.length > 1)
const randomVideoId = computed(() => {
  const videoIds = [
    'ca3b5a8a-525d-4013-9244-d93461e4d27b',
    '4f5f9453-a6c1-4d67-9cbf-176fd69dff28',
    '4a40bcd0-05de-4224-8c8b-13b40a284626',
    '5fa667c7-2974-4c20-86b5-303e9361bb54'
  ]
  const index = Math.floor(Math.random() * Math.floor(videoIds.length))
  return videoIds[index]
})
const title = computed(() => {
  const is404 = props?.error?.statusCode === 404
  if ($lang === 'de') {
    return is404 ? 'Oops, wir können es nicht finden!' : 'Oops, etwas ist schief gelaufen!'
  }
  if ($lang === 'en') {
    return is404 ? "Oops, we can't find that!" : 'Oops, something went wrong!'
  }
  return is404 ? 'Oops, we kunnen het niet vinden!' : 'Oops, er ging iets mis!'
})
const subTitle = computed(() => {
  if ($lang === 'de') {
    return 'Es liegt nicht an dir, sondern an uns...'
  }
  if ($lang === 'en') {
    return "It's not you, it's us..."
  }
  return 'Het ligt niet aan jou, maar aan ons...'
})

onMounted(() => {
  console.error(props?.error?.stack)
})

</script>
<style lang="scss">
.error-message {
    font-size: $font-size-l;
    min-height: calc(80vh - var(--toolbar-height));
    margin: 0 auto;

    padding-bottom: $spacing * 4;
    text-align: center;
    max-width: 600px;
    width: 100%;

    &__video-wrapper {
        display: block;
        flex: 0;
        position: relative;
        aspect-ratio: 1/1;
        max-width: 600px;
        width: auto;
        height: auto;
    }
}
</style>
